"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import WavesListSearch from "./WavesListSearch";
import { AuthContext } from "@/components/auth/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
export default function WavesListHeader(t0) {
  const $ = _c(32);
  const {
    title: t1,
    identity,
    waveName,
    showCreateNewButton,
    onCreateNewWave,
    onCreateNewDirectMessage,
    setIdentity,
    setWaveName
  } = t0;
  const title = t1 === undefined ? "Waves" : t1;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t2;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile?.handle) {
    t2 = () => !!connectedProfile?.handle && !activeProfileProxy;
    $[0] = activeProfileProxy;
    $[1] = connectedProfile?.handle;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getShowMyWavesButton = t2;
  const [showMyWavesButton, setShowMyWavesButton] = useState(getShowMyWavesButton());
  let t3;
  if ($[3] !== getShowMyWavesButton) {
    t3 = () => setShowMyWavesButton(getShowMyWavesButton());
    $[3] = getShowMyWavesButton;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activeProfileProxy || $[6] !== connectedProfile) {
    t4 = [connectedProfile, activeProfileProxy];
    $[5] = activeProfileProxy;
    $[6] = connectedProfile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== title) {
    t5 = <h1>{title}</h1>;
    $[8] = title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== identity || $[11] !== setIdentity || $[12] !== setWaveName || $[13] !== waveName) {
    t6 = <WavesListSearch identity={identity} waveName={waveName} setWaveName={setWaveName} setIdentity={setIdentity} />;
    $[10] = identity;
    $[11] = setIdentity;
    $[12] = setWaveName;
    $[13] = waveName;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== connectedProfile?.handle || $[16] !== setIdentity || $[17] !== showMyWavesButton) {
    t7 = showMyWavesButton && <button onClick={() => !!connectedProfile?.handle && setIdentity(connectedProfile?.handle)} type="button" className="tw-whitespace-nowrap tw-text-sm tw-font-semibold tw-inline-flex tw-items-center tw-rounded-lg tw-bg-iron-200 tw-px-3.5 tw-py-2.5 tw-text-iron-800 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-border-0 tw-ring-1 tw-ring-inset tw-ring-white hover:tw-bg-iron-300 hover:tw-ring-iron-300 focus:tw-z-10 tw-transition tw-duration-300 tw-ease-out">My Waves</button>;
    $[15] = connectedProfile?.handle;
    $[16] = setIdentity;
    $[17] = showMyWavesButton;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== onCreateNewDirectMessage || $[20] !== onCreateNewWave || $[21] !== showCreateNewButton) {
    t8 = showCreateNewButton && <><div className="tw-p-[1px] tw-flex tw-rounded-lg tw-bg-gradient-to-b tw-from-primary-400 tw-to-primary-500 tw-gap-x-1"><button onClick={onCreateNewWave} type="button" className="tw-flex tw-items-center tw-whitespace-nowrap tw-border-0 tw-rounded-lg tw-bg-primary-500 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-primary-600 hover:tw-border-primary-600 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-600 tw-transition tw-duration-300 tw-ease-out"><svg className="tw-size-5 tw-mr-1.5 -tw-ml-1.5 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span>Create Wave</span></button></div><div className="tw-p-[1px] tw-flex tw-rounded-lg tw-bg-gradient-to-b tw-from-primary-400 tw-to-primary-500 tw-gap-x-1"><button onClick={onCreateNewDirectMessage} type="button" className="tw-flex tw-items-center tw-whitespace-nowrap tw-border-0 tw-rounded-lg tw-bg-primary-500 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-primary-600 hover:tw-border-primary-600 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-600 tw-transition tw-duration-300 tw-ease-out"><FontAwesomeIcon icon={faPaperPlane} className="tw-size-4 tw-mr-2 -tw-ml-1 tw-flex-shrink-0" /><span>Create DM</span></button></div></>;
    $[19] = onCreateNewDirectMessage;
    $[20] = onCreateNewWave;
    $[21] = showCreateNewButton;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t7 || $[24] !== t8) {
    t9 = <div className="tw-flex tw-gap-3 tw-items-center">{t7}{t8}</div>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t6 || $[27] !== t9) {
    t10 = <div className="tw-mt-4 md:tw-mt-6 tw-flex tw-flex-col lg:tw-flex-row tw-w-full lg:tw-items-center tw-justify-between tw-gap-4">{t6}{t9}</div>;
    $[26] = t6;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t5) {
    t11 = <div className="tw-mt-4 md:tw-mt-8">{t5}{t10}</div>;
    $[29] = t10;
    $[30] = t5;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}